import ReportItemTransfer from '../../../../components/@reports/warehouse/ReportItemTransfer';

import { ReportContextProvider } from '../../../../context/ReportContext';

import { reportScopes, reportTypes } from '../../../../hooks/api/useReports';

import { routeTypes } from '../../../../hooks/useSystemRoutes';

import {
  validationSchema,
  initialValues,
  advancedValidationSchema,
  advancedInitialValues,
} from '../../../../schema/reports/warehouse/itemTransferSchema';

export default function ItemTransferReport() {
  let routeType = routeTypes.retail;

  return (
    <ReportContextProvider
      routeType={routeType}
      reportScope={reportScopes.warehouse}
      reportType={reportTypes.warehouse.itemTransfer.id}
      validationSchema={validationSchema}
      advancedValidationSchema={advancedValidationSchema}
      initialValues={initialValues}
      advancedInitialValues={advancedInitialValues}
    >
      <ReportItemTransfer routeType={routeType} />
    </ReportContextProvider>
  );
}
